// @flow
import AvailableDishesTable from './AvailableDishesTable';

export default AvailableDishesTable;
